"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ListItem = exports.List = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var List = _styledComponents["default"].div.attrs({
  className: "List"
}).withConfig({
  displayName: "styles__List"
})(["width:100%;@media (min-width:768px){display:flex;flex-wrap:wrap;}"]);

exports.List = List;

var ListItem = _styledComponents["default"].div.withConfig({
  displayName: "styles__ListItem"
})(["flex-basis:100%;@media (min-width:768px){flex-basis:", ";}"], function (a) {
  return "calc(100%/".concat(a.columns, ")");
});

exports.ListItem = ListItem;